import { createAction } from '@reduxjs/toolkit';

import { SimpleSettingsState } from '../reducers/simpleSettings.reducer';

import { ValueOf } from 'Types/common.types';

export const simpleSettingSet = createAction<{
  key: keyof SimpleSettingsState;
  value: ValueOf<SimpleSettingsState>;
}>('simpleSettings/set');
